/* ==========================================================================
   Ryse - Theoric PDP: topo (novo modelo)
   1. Selo do desconto no Pix (-X%), calculado a partir do proprio DOM
   2. Descricao truncada em N linhas com botao "ler mais"
   ========================================================================== */
(() => {
  if (window.TheoricPdpTop) return;

  const LINHAS_DESCRICAO = 5;

  function moedaParaNumero(texto) {
    if (!texto) return NaN;
    const achado = texto.replace(/\s/g, '').match(/([\d.]*\d,\d{2})/);
    if (!achado) return NaN;
    return parseFloat(achado[1].replace(/\./g, '').replace(',', '.'));
  }

  function injetarSeloPix(raiz) {
    const linhaPreco = raiz.querySelector('.theoric-pdp__price-row');
    if (!linhaPreco || linhaPreco.querySelector('.theoric-pdp__price-off')) return;

    const valorEl = linhaPreco.querySelector('.theoric-pdp__price-value');
    const parceladoEl = raiz.querySelector('.theoric-pdp__installment-text');
    if (!valorEl || !parceladoEl) return;

    const precoPix = moedaParaNumero(valorEl.textContent);

    const valorParcelaEl = parceladoEl.querySelector('strong');
    const valorParcela = moedaParaNumero(valorParcelaEl ? valorParcelaEl.textContent : '');

    const qtd = parceladoEl.textContent.match(/(\d+)\s*x\s*de/i);
    if (!precoPix || !valorParcela || !qtd) return;

    const precoCheio = valorParcela * parseInt(qtd[1], 10);
    if (!precoCheio || precoCheio <= precoPix) return;

    const percentual = Math.round(((precoCheio - precoPix) / precoCheio) * 100);
    if (percentual <= 0) return;

    const selo = document.createElement('span');
    selo.className = 'theoric-pdp__price-off';
    selo.textContent = '-' + percentual + '%';
    linhaPreco.appendChild(selo);
  }

  function truncarDescricao(raiz) {
    const desc = raiz.querySelector('.theoric-pdp__description');
    if (!desc || desc.dataset.clampIniciado === 'true') return;
    desc.dataset.clampIniciado = 'true';

    desc.classList.remove('is-expanded');
    desc.classList.add('is-clamped');

    if (desc.scrollHeight <= desc.clientHeight + 2) {
      desc.classList.remove('is-clamped');
      return;
    }

    const botao = document.createElement('button');
    botao.type = 'button';
    botao.className = 'theoric-pdp__desc-toggle';
    botao.textContent = 'ler mais';
    botao.setAttribute('aria-expanded', 'false');

    botao.addEventListener('click', () => {
      const truncado = desc.classList.toggle('is-clamped');
      botao.textContent = truncado ? 'ler mais' : 'ler menos';
      botao.setAttribute('aria-expanded', truncado ? 'false' : 'true');
    });

    desc.insertAdjacentElement('afterend', botao);
  }

  function iniciar(raiz) {
    const escopo =
      (raiz && raiz.querySelector && raiz.querySelector('.theoric-main-product')) ||
      document.querySelector('.theoric-main-product');
    if (!escopo) return;

    injetarSeloPix(escopo);
    truncarDescricao(escopo);
  }

  window.TheoricPdpTop = { init: iniciar, LINHAS_DESCRICAO };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => iniciar(document));
  } else {
    iniciar(document);
  }

  document.addEventListener('product-info:loaded', (evento) => iniciar(evento.target));
  document.addEventListener('shopify:section:load', (evento) => iniciar(evento.target));
})();
